import React from 'react';
import logo from '../../../img/Original.png';

const HomeAdministrador = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'min(calc(100dvh - 56px), calc(100vh - 56px))',
      width: '100%',
      padding: '12px max(12px, env(safe-area-inset-right)) 24px max(12px, env(safe-area-inset-left))',
      boxSizing: 'border-box',
    }}
  >
    <img
      src={logo}
      alt="Global"
      style={{
        maxWidth: 'min(92vw, 520px)',
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
      }}
    />
  </div>
);

export default HomeAdministrador;
